// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from InputText.module.scss  */
/* stylelint-disable */
.InputText-module-Root_2jR,
.InputText-module-Addon_dEw {
  display: flex; }

.InputText-module-Root_2jR {
  align-items: center; }
  .InputText-module-Root_2jR [name='clearInput'] {
    color: var(--input-text-clear-color); }

.InputText-module-Addon_dEw {
  flex-shrink: 0;
  align-items: center; }
  .InputText-module-Addon_dEw:empty {
    display: none; }
  .InputText-module-Addon_dEwAfter {
    padding-right: var(--input-text-addon-after-padding-right); }
    .InputText-module-Addon_dEwAfter button[name='clearInput'] {
      margin-right: var(--input-text-addon-after-buttons-margin-left); }
      .InputText-module-Addon_dEwAfter button[name='clearInput'] ~ button {
        margin-right: 0;
        margin-left: calc(-1 * var(--input-text-addon-after-buttons-margin-left)); }

.InputText-module-Input_q36 {
  display: block;
  flex-shrink: 1;
  box-sizing: border-box;
  width: 100%;
  font-family: var(--input-text-font);
  border: 0;
  border-radius: 8px;
  outline: 0;
  background: transparent;
  appearance: none; }
  .InputText-module-Input_q36::-webkit-input-placeholder {
    color: #9199a3; }
  .InputText-module-Input_q36:-ms-input-placeholder {
    color: #9199a3; }
  .InputText-module-Input_q36::placeholder {
    color: #9199a3; }
  .InputText-module-Input_q36:-webkit-autofill, .InputText-module-Input_q36:-webkit-autofill:hover, .InputText-module-Input_q36:-webkit-autofill:focus, .InputText-module-Input_q36:-webkit-autofill:active {
    background-color: #fff !important;
    background-clip: content-box !important;
    -webkit-box-shadow: 0 0 0 60px #fff inset !important; }
  .InputText-module-Input_q36:focus::-webkit-input-placeholder {
    color: transparent; }
  .InputText-module-Input_q36:focus:-ms-input-placeholder {
    color: transparent; }
  .InputText-module-Input_q36:focus::placeholder {
    color: transparent; }

.InputText-module-lSize_1mO {
  height: var(--input-text-height);
  font-size: var(--input-text-font-size); }

.InputText-module-mSize_2_k {
  height: var(--input-text-m-height);
  font-size: var(--input-text-m-font-size); }

textarea.InputText-module-Input_q36 {
  height: auto;
  min-height: var(--input-text-textarea-min-height);
  resize: none; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/InputText/InputText.css"],"names":[],"mappings":"AAAA,0CAA0C;AAC1C,sBAAsB;AACtB;;EAEE,aAAa,EAAE;;AAEjB;EACE,mBAAmB,EAAE;EACrB;IACE,oCAAoC,EAAE;;AAE1C;EACE,cAAc;EACd,mBAAmB,EAAE;EACrB;IACE,aAAa,EAAE;EACjB;IACE,0DAA0D,EAAE;IAC5D;MACE,+DAA+D,EAAE;MACjE;QACE,eAAe;QACf,yEAAyE,EAAE;;AAEnF;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,gBAAgB,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,cAAc,EAAE;EAClB;IACE,iCAAiC;IACjC,uCAAuC;IACvC,oDAAoD,EAAE;EACxD;IACE,kBAAkB,EAAE;EACtB;IACE,kBAAkB,EAAE;EACtB;IACE,kBAAkB,EAAE;;AAExB;EACE,gCAAgC;EAChC,sCAAsC,EAAE;;AAE1C;EACE,kCAAkC;EAClC,wCAAwC,EAAE;;AAE5C;EACE,YAAY;EACZ,iDAAiD;EACjD,YAAY,EAAE","sourcesContent":["/*  imported from InputText.module.scss  */\n/* stylelint-disable */\n.InputText-module-Root_2jR,\n.InputText-module-Addon_dEw {\n  display: flex; }\n\n.InputText-module-Root_2jR {\n  align-items: center; }\n  .InputText-module-Root_2jR [name='clearInput'] {\n    color: var(--input-text-clear-color); }\n\n.InputText-module-Addon_dEw {\n  flex-shrink: 0;\n  align-items: center; }\n  .InputText-module-Addon_dEw:empty {\n    display: none; }\n  .InputText-module-Addon_dEwAfter {\n    padding-right: var(--input-text-addon-after-padding-right); }\n    .InputText-module-Addon_dEwAfter button[name='clearInput'] {\n      margin-right: var(--input-text-addon-after-buttons-margin-left); }\n      .InputText-module-Addon_dEwAfter button[name='clearInput'] ~ button {\n        margin-right: 0;\n        margin-left: calc(-1 * var(--input-text-addon-after-buttons-margin-left)); }\n\n.InputText-module-Input_q36 {\n  display: block;\n  flex-shrink: 1;\n  box-sizing: border-box;\n  width: 100%;\n  font-family: var(--input-text-font);\n  border: 0;\n  border-radius: 8px;\n  outline: 0;\n  background: transparent;\n  appearance: none; }\n  .InputText-module-Input_q36::-webkit-input-placeholder {\n    color: #9199a3; }\n  .InputText-module-Input_q36:-ms-input-placeholder {\n    color: #9199a3; }\n  .InputText-module-Input_q36::placeholder {\n    color: #9199a3; }\n  .InputText-module-Input_q36:-webkit-autofill, .InputText-module-Input_q36:-webkit-autofill:hover, .InputText-module-Input_q36:-webkit-autofill:focus, .InputText-module-Input_q36:-webkit-autofill:active {\n    background-color: #fff !important;\n    background-clip: content-box !important;\n    -webkit-box-shadow: 0 0 0 60px #fff inset !important; }\n  .InputText-module-Input_q36:focus::-webkit-input-placeholder {\n    color: transparent; }\n  .InputText-module-Input_q36:focus:-ms-input-placeholder {\n    color: transparent; }\n  .InputText-module-Input_q36:focus::placeholder {\n    color: transparent; }\n\n.InputText-module-lSize_1mO {\n  height: var(--input-text-height);\n  font-size: var(--input-text-font-size); }\n\n.InputText-module-mSize_2_k {\n  height: var(--input-text-m-height);\n  font-size: var(--input-text-m-font-size); }\n\ntextarea.InputText-module-Input_q36 {\n  height: auto;\n  min-height: var(--input-text-textarea-min-height);\n  resize: none; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
